<template>
  <div class="block border-l-4 border-coal pl-3 py-1">
    <h1
      class="text-coal text-xl md:text-3xl lg:text-4xl uppercase font-extrabold"
    >
      {{ lang === "mn" ? "Мэдээлэл байршуулах" : "Registration" }}
    </h1>
    <p class="text-gray-500 max-sm:text-sm uppercase mt-2">
      {{
        lang === "mn"
          ? "Та байгууллагынхаа мэдээллийг лавлахад нийтлэх боломжтой. Таны илгээсэн хүсэлтийг админ хянаж зөвшөөрсний дараагаар мэдээллийг олон нийтэд нээлттэй болгоно."
          : "You have the opportunity to publish your organization's information in the reference section. Once your submitted request has been reviewed and approved by the administrator, your information will be made publicly accessible."
      }}
    </p>
  </div>

  <section class="mt-10 mb-20">
    <div>
      <h1 class="uppercase text-lg text-coal">
        {{
          lang === "mn"
            ? "Бүртгүүлэгчийн мэдээлэл"
            : "Information of the Registrant"
        }}
      </h1>
      <p class="text-gray-500 text-sm">
        {{
          lang === "mn"
            ? "Байгууллагын мэдээллийг бүртгүүлж буй албан ёсны төлөөлөгчийн мэдээллийг үнэн зөв бөглөнө үү."
            : "Please enter accurate information of the authorized representative registering the company."
        }}
      </p>
    </div>

    <p class="text-gray-500 text-sm italic my-5">
      <span class="text-red-500">*</span> -
      {{ lang === "mn" ? "Заавал бөглөх" : "Must be filled" }}
    </p>

    <div class="flex max-sm:flex-col gap-5 md:gap-10 w-full">
      <div class="w-full">
        <label for="name"
          >{{ lang === "mn" ? "Ажилтны нэр:" : "Employer's Full Name:"
          }}<span class="text-red-500">*</span></label
        >
        <input
          id="name"
          name="name"
          type="text"
          :placeholder="lang === 'mn' ? 'Нэр' : 'Name'"
          class="w-full p-2 border"
          :class="errors.name ? 'border-red-500' : ''"
          v-model="form.name"
          @input="errors.name = false"
        />
        <p v-if="errors.name" class="text-red-500 text-sm mt-1">
          {{
            lang === "mn"
              ? "Энэ талбарыг бөглөнө үү."
              : "Please fill out this field."
          }}
        </p>
      </div>

      <div class="w-full">
        <label for="position"
          >{{ lang === "mn" ? "Албан тушаал:" : "Employee's position:"
          }}<span class="text-red-500">*</span></label
        >
        <input
          id="position"
          name="position"
          type="text"
          :placeholder="lang === 'mn' ? 'Албан тушаал' : 'Position'"
          class="w-full p-2 border"
          :class="errors.position ? 'border-red-500' : ''"
          v-model="form.position"
          @input="errors.position = false"
        />
        <p v-if="errors.position" class="text-red-500 text-sm mt-1">
          {{
            lang === "mn"
              ? "Энэ талбарыг бөглөнө үү."
              : "Please fill out this field."
          }}
        </p>
      </div>
    </div>

    <div class="flex max-sm:flex-col gap-5 md:gap-10 w-full mt-5">
      <div class="w-full">
        <label for="email"
          >{{ lang === "mn" ? "Цахим шуудан:" : "Employee's e-mail:"
          }}<span class="text-red-500">*</span></label
        >
        <input
          id="email"
          name="email"
          type="email"
          :placeholder="lang === 'mn' ? `Цахим шуудан` : 'E-mail'"
          class="w-full p-2 border"
          :class="errors.email ? 'border-red-500' : ''"
          v-model="form.email"
          @input="errors.email = false"
        />
        <p v-if="errors.email" class="text-red-500 text-sm mt-1">
          {{
            lang === "mn"
              ? "Энэ талбарыг бөглөнө үү."
              : "Please fill out this field."
          }}
        </p>
      </div>

      <div class="w-full">
        <label for="phone"
          >{{ lang === "mn" ? "Утасны дугаар:" : "Employee's Phone Number:"
          }}<span class="text-red-500">*</span></label
        >
        <input
          id="phone"
          name="phone"
          type="text"
          :placeholder="lang === 'mn' ? `Утас` : 'Phone'"
          class="w-full p-2 border"
          :class="errors.phone ? 'border-red-500' : ''"
          v-model="form.phone"
          @input="errors.phone = false"
        />
        <p v-if="errors.phone" class="text-red-500 text-sm mt-1">
          {{
            lang === "mn"
              ? "Энэ талбарыг бөглөнө үү."
              : "Please fill out this field."
          }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";

export default {
  name: "YellowRegistrationStepOne",
  props: {
    registrant: Object,
  },
  setup(props, { expose }) {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const form = ref({
      name: "",
      position: "",
      email: "",
      phone: "",
    });

    onMounted(() => {
      if (props.registrant) {
        form.value = {
          name: props.registrant.name,
          position: props.registrant.position,
          email: props.registrant.email,
          phone: props.registrant.phone,
        };
      }
    });

    const errors = ref({
      name: false,
      position: false,
      email: false,
      phone: false,
    });

    const validateForm = () => {
      let valid = true;
      Object.keys(form.value).forEach((key) => {
        if (!form.value[key]) {
          errors.value[key] = true;
          valid = false;
        } else {
          errors.value[key] = false;
        }
      });
      return valid;
    };

    expose({ validateForm, form });

    return { lang, form, errors };
  },
};
</script>
